import { createSlice } from "@reduxjs/toolkit";
import { filterTestsForDisplay } from "../../Utils/TestNames";

// Get tests from localStorage or default to []
const storedRawTests = JSON.parse(localStorage.getItem("testsData")) || [];
const storedTest = filterTestsForDisplay(storedRawTests);

const initialState = {
  testsData: storedTest,
  referedBy: localStorage.getItem("referedBy") || "",
  testInstruction: localStorage.getItem("testInstruction") || null,
  dateTime: localStorage.getItem("dateTime") || null,
};

const testSlice = createSlice({
  name: "testSlice",
  initialState,
  reducers: {
    setTestsData: (state, action) => {
      const filtered = filterTestsForDisplay(action.payload);
      state.testsData = filtered;
      localStorage.setItem("testsData", JSON.stringify(filtered));
    },
    addTests: (state, action) => {
      const filtered = filterTestsForDisplay(action.payload);
      state.testsData = filtered;
      localStorage.setItem("testsData", JSON.stringify(filtered));
    },
    setTestResults: (state, action) => {

    
      const resultsMap = action.payload || {};
      const hasOwn = (key) =>
        Object.prototype.hasOwnProperty.call(resultsMap, key);
    
      const groups = Array.isArray(state.testsData) ? state.testsData : [];
    

    
      groups.forEach((group, gIndex) => {
        // console.group(`📂 Group #${gIndex + 1} → ${group?.groupName || "N/A"}`);

    
        group.options?.forEach((option, oIndex) => {
          const optId = option?.ParameterID;
    
          // console.group(`🔸 Option #${oIndex + 1}`);

    
          // Set main option result
          if (optId && hasOwn(optId)) {
            option.result = resultsMap[optId];

          } 
    
          // Determine sub-tests
          const subArray =
            Array.isArray(option?.subTests)
              ? option.subTests
              : Array.isArray(option?.subTest)
              ? option.subTest
              : [];

    
          // Process sub-tests
          subArray.forEach((sub, sIndex) => {
            const subId = sub?.ParameterID || sub?.id;
    

    
            if (subId && hasOwn(subId)) {
              sub.result = resultsMap[subId];

            } 
    
            // console.groupEnd(); // end subtest
          });
    
          // Normalize subTests
          if (!option.subTests && Array.isArray(option?.subTest)) {
            option.subTests = option.subTest;

          }
    
          // console.groupEnd(); // end option
        });
    
        console.groupEnd(); // end group
      });
    

      localStorage.setItem("testsData", JSON.stringify(state.testsData));
    
      console.groupEnd(); // end reducer
    },
    
    addDateTime: (state, action) => {
      state.dateTime = action.payload;
      localStorage.setItem("dateTime", JSON.stringify(action.payload));
    },
    addReferedBy: (state, action) => {
      state.referedBy = action.payload;
      localStorage.setItem("referedBy", action.payload);
    },
    addTestInstruction: (state, action) => {
      state.testInstruction = action.payload;
      localStorage.setItem("testInstruction", action.payload);
    },
    clearReportContext: (state) => {
      state.testsData = [];
      state.referedBy = "";
      state.testInstruction = null;
      state.dateTime = null;

      localStorage.removeItem("testsData");
      localStorage.removeItem("referedBy");
      localStorage.removeItem("testInstruction");
      localStorage.removeItem("dateTime");
      localStorage.removeItem("reportLink");
    },
  },
});


export const {
  setTestsData,    // <--- use this in your component!
  addTests,
  setTestResults,
  addReferedBy,
  addTestInstruction,
  addDateTime,
  clearReportContext,
} = testSlice.actions;

export default testSlice.reducer;
